import { Dialog, DialogContent, DialogTitle, GlobalStyles, SvgIconProps } from '@mui/material';
import { ComponentType, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AstroSmartLinkDomain } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import { NavSubListItemLink } from '~/components/NavSubListItemLink/NavSubListItemLink';
import { SmartLinkGridForm } from '~/components/SmartLinks/components/SmartLinkGridForm';

interface SmartLinksEditDialogProps {
  dialogTitle: string;
  domain: AstroSmartLinkDomain;
  Icon?: ComponentType<SvgIconProps>;
  label: string;
}

export const SmartLinksEditDialog = ({ dialogTitle, domain, Icon, label }: SmartLinksEditDialogProps) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'Nav' });
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Disable pointer events to prevent reordering (mouse events) hijacking */}
      {open && (
        <GlobalStyles
          styles={{
            iframe: {
              pointerEvents: 'none',
            },
          }}
        />
      )}
      <NavSubListItemLink id={label} Icon={Icon} onClick={() => setOpen(true)} />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            zIndex: 1300,
            maxWidth: '100%',
            minHeight: '50%',
          },
        }}
      >
        <DialogTitle>{t(dialogTitle)}</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
          <SmartLinkGridForm domain={domain} />
        </DialogContent>
      </Dialog>
    </>
  );
};
